<div class="main">
    <div class="dialogue">
        <h1>You are just about to leave for this awesome party you have been awaiting for days</h1>
        <h2>....carkey, wallet. okay got everything. Lets gooo</h2>
        <button class = "custbutton" routerLink="/middle" style="align-self: center;">Leave door</button>
    </div>
</div>